class CollectionQuickAdd extends HTMLElement {
    constructor () {
      super()
  
      this.trigger = this.parentElement.querySelector('.open-quick-add')
      this.drawer = this.querySelector('.collection-quick-add')
      this.close = this.querySelector('.collection-quick-add__close')
      this.initialiseCollectionQuickAdd()
    }
  
    initialiseCollectionQuickAdd () {

      if (!this.trigger || !this.drawer || !this.close) return
      
      this.handleClick = this.handleClick.bind(this)
      this.trigger.addEventListener('click', this.handleClick)

      this.closeThisDrawer = this.closeThisDrawer.bind(this)
      this.close.addEventListener('click', this.closeThisDrawer)

    }
  
    handleClick () {
      this.clearOpenDrawers()
      this.drawer.classList.toggle('open')
    }

    closeThisDrawer () {
      this.drawer.classList.remove('open')
    }

    clearOpenDrawers () {
      document.querySelectorAll('.collection-quick-add').forEach(drawer => {
        drawer.classList.remove('open')
      })
    }
  }
  
  customElements.define('collection-quick-add', CollectionQuickAdd)
  